import { render, staticRenderFns } from "./UpdateLayout.vue?vue&type=template&id=b9fd433c&scoped=true"
import script from "./UpdateLayout.vue?vue&type=script&lang=js"
export * from "./UpdateLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9fd433c",
  null
  
)

export default component.exports